import React from 'react';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'utils/types';

import { actions as addressActions } from 'state/addresses';
import { debouncedAction } from 'utils/debounce';

import addressesSelectors from 'state/addresses/selectors';

import AddressCompanyNameFieldComponent from 'components/AddressModal/components/AddressCompanyNameField/component';
import { constants as addressesConstants } from 'utils/addresses';

const runDebouncedAction = debouncedAction(
  addressesConstants.DEBOUNCE_SEARCH_INTERVAL
);

const enhance = compose(
  withState('focused', 'setFocused', false),
  withTranslation('AddressFormModal'),
  connect(
    (state) => ({
      loadedVenuesOfInterest:
        addressesSelectors.getLoadedVenuesOfInterest(state),
    }),
    {
      searchVenueOfInterest: addressActions.searchVenuesOfInterest,
      clearVenuesOfInterest: addressActions.clearVenuesOfInterest,
    }
  ),
  withProps(
    ({
      addressSuggestionsEnabled = true,
      zipcode,
      country,
      city,
      loadedVenuesOfInterest,
      error,
      invalid,
      companyName,
    }) => ({
      addressSuggestionsEnabled,
      zipcode,
      country,
      city,
      venues: loadedVenuesOfInterest,
      error,
      invalid,
      companyName,
      names: addressesConstants.FIELDS_NAMES,
    })
  ),
  withHandlers(() => {
    let modalRef = React.createRef();
    let inputRef = React.createRef();
    let inputModalRef = React.createRef();
    return {
      handleSuggestionSelected:
        ({ setFocused, onSuggestionClick }) =>
        (addressSuggestion) => {
          if (modalRef && modalRef.close) modalRef.close();
          setFocused(false);
          onSuggestionClick(addressSuggestion);
        },
      closeCompanyNameModal:
        ({ setFocused }) =>
        () => {
          if (modalRef && modalRef.close) modalRef.close();
          setFocused(false);
        },
      handleInputFocus:
        ({ setFocused }) =>
        () => {
          if (!inputRef || isEmpty(inputRef)) return;

          setFocused(true);
          inputRef.focus();
        },
      handleInputModalFocus:
        ({ setFocused }) =>
        () => {
          if (!inputModalRef || isEmpty(inputModalRef)) return;

          setFocused(true);
          inputModalRef.focus();
        },
      handleInputBlur:
        ({ setFocused, clearVenuesOfInterest }) =>
        () => {
          setFocused(false);
          clearVenuesOfInterest();
        },
      responsiveModalRef: () => (ref) => {
        modalRef = ref;
      },
      inputRef: () => (ref) => {
        inputRef = ref;
      },
      inputModalRef: () => (ref) => {
        inputModalRef = ref;
      },
      handleChange:
        ({
          addressSuggestionsEnabled,
          searchVenueOfInterest,
          onChange,
          zipcode,
          country,
          city,
        }) =>
        (_, { name, value }) => {
          if (addressSuggestionsEnabled) {
            runDebouncedAction(
              { text: value, postalCode: zipcode, countryCode: country, city },
              searchVenueOfInterest
            );
          }
          onChange(_, {
            name,
            value: value || '',
          });
        },
    };
  })
);

const AddressCompanyNameField = enhance(AddressCompanyNameFieldComponent);

export default AddressCompanyNameField;
